import { Link } from "react-router-dom";
import { UserPlus, Search, Heart, DollarSign, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function HowItWorks() {
  return (
    <div className="pt-32 pb-20">
      <section className="max-w-4xl mx-auto px-6 text-center">
        <Reveal>
          <p className="overline text-brand mb-4">Getting Started</p>
          <h1 className="font-display text-5xl md:text-6xl text-white">How It Works</h1>
          <p className="mt-5 text-white/60 text-lg">Two paths, one platform. Pick yours and get moving.</p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 mt-16 grid lg:grid-cols-2 gap-8">
        <div className="card p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-11 w-11 rounded-full bg-pink-500/15 grid place-items-center"><UserPlus className="text-brand" size={20} /></div>
            <h2 className="font-display text-3xl text-brand">For Creators</h2>
          </div>
          {[["Join","Create your account in minutes."],
            ["Build","Set up your profile, upload content, and configure offers."],
            ["Grow","Use AutoPilot Mode + our discovery engine to reach real fans."],
            ["Earn","Keep 70% of every purchase, tip, and subscription."]].map(([t,d],i)=>(
            <Reveal key={i} delay={i*0.05}>
              <div className="py-4 border-b border-white/10 last:border-0 flex gap-4">
                <span className="font-display text-3xl text-brand w-10">{String(i+1).padStart(2,"0")}</span>
                <div><div className="text-white font-semibold">{t}</div><div className="text-white/60 text-sm">{d}</div></div>
              </div>
            </Reveal>
          ))}
          <Link to="/signup?type=creator" className="mt-6 inline-flex items-center gap-2 bg-brand text-white px-6 py-3 rounded-lg font-semibold" data-testid="hiw-creator">Join as a Creator <ArrowRight size={15} /></Link>
        </div>

        <div className="card p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-11 w-11 rounded-full bg-violet-500/15 grid place-items-center"><Heart className="text-violet-300" size={20} /></div>
            <h2 className="font-display text-3xl text-violet-300">For Fans</h2>
          </div>
          {[["Sign Up Free","No fees. Ever. Just tell us what you're into."],
            ["Discover","We recommend creators based on your interests."],
            ["Connect","Follow, save, and get updates from creators you love."],
            ["Support","Subscribe, tip, or unlock content — creators get 70%."]].map(([t,d],i)=>(
            <Reveal key={i} delay={i*0.05}>
              <div className="py-4 border-b border-white/10 last:border-0 flex gap-4">
                <span className="font-display text-3xl text-violet-300 w-10">{String(i+1).padStart(2,"0")}</span>
                <div><div className="text-white font-semibold">{t}</div><div className="text-white/60 text-sm">{d}</div></div>
              </div>
            </Reveal>
          ))}
          <Link to="/signup?type=fan" className="mt-6 inline-flex items-center gap-2 bg-violet-500 text-white px-6 py-3 rounded-lg font-semibold" data-testid="hiw-fan">Join Free as a Fan <Search size={15} /></Link>
        </div>
      </section>
    </div>
  );
}
